import * as React from "react";
import { cn } from "../../lib/utils";

const steps = ["Select Video to Test", "Upload", "Test Settings", "Get Views!"];

type AddTestStepperProps = {
  activeStep: number;
};

export default function AddTestStepper({ activeStep }: AddTestStepperProps) {
  return (
    <div className="w-full px-6 py-4">
      <div className="flex items-start justify-between relative">
        <div className="absolute top-5 left-0 right-0 h-0.5 bg-muted -z-10 mx-[calc(100%/(2*4))]">
          <div
            className="h-full bg-primary transition-all duration-300"
            style={{ width: `${(activeStep / (steps.length - 1)) * 100}%` }}
          />
        </div>

        {steps.map((label, index) => {
          const isActive = index === activeStep;
          const isCompleted = index < activeStep;

          return (
            <div key={label} className="flex flex-col items-center flex-1 relative z-10">
              <div
                className={cn(
                  "w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-300 border-2",
                  isCompleted
                    ? "bg-primary border-primary text-primary-foreground"
                    : isActive
                    ? "bg-primary border-primary text-primary-foreground ring-4 ring-primary/20"
                    : "bg-background border-border text-muted-foreground"
                )}
              >
                {isCompleted ? "✓" : index + 1}
              </div>
              <div
                className={cn(
                  "mt-2 text-xs text-center max-w-[100px]",
                  isActive
                    ? "text-primary font-semibold"
                    : isCompleted
                    ? "text-foreground"
                    : "text-muted-foreground"
                )}
              >
                {label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
